import React, { FC } from "react";
import { Button, Modal } from "react-bootstrap";

export type ApModalProps = {
  show: boolean;
  onHide: () => void;
  backdrop?: boolean | "static";
  keyboard?: boolean;
  autoFocus?: boolean;
};

type ApModalDialogProps = {
  props: ApModalProps;
  onOkay?: () => void;
  header: boolean;
  headerText?: string;
  footer: boolean;
  okText?: string;
  closeText?: string;
  children?: React.ReactNode;
  size?: "sm" | "lg" | "xl";
  dialogClassName?: string;
};

const ApModalDialog: FC<ApModalDialogProps> = ({
  props,
  onOkay,
  header,
  headerText,
  footer,
  okText,
  closeText,
  children,
  size,
  dialogClassName,
}) => {
  return (
    <Modal
      {...props}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName={dialogClassName}
    >
      {header && (
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"> {headerText}</Modal.Title>{" "}
        </Modal.Header>
      )}
      {children && <Modal.Body className="p-4">{children}</Modal.Body>}
      {footer && (
        <Modal.Footer>
          {onOkay && (
            <Button color="Blue" onClick={() => onOkay()}>
              {okText ?? "OK"}
            </Button>
          )}
          <Button color="Default" onClick={props.onHide}>
            {closeText ?? "Close"}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ApModalDialog;
